<template>
  <div class="additionalInfo__agreements">
    <ValidationProvider
      v-if="getProductType === 'ECV_ISS'"
      :rules="{ required: { allowFalse: false } }"
      class="additionalForm__agreements" name="isVirtualCardDataOwnershipChecked"
      ref="isVirtualCardDataOwnershipChecked"
      tag="div"
      v-slot="{ errors, dirty, valid , classes }">

      <div>
        <label class="checkbox-inline required text-collapse" :class="errors.length > 0 ? 'invalid' : ''">
          <input
            class="dl-checked"
            name="isVirtualCardDataOwnershipChecked"
            type="checkbox"
            v-model="isVirtualCardDataOwnershipChecked" >
          Oświadczam, że jestem administratorem danych osobowych (w tym: imię, nazwisko i adres email)
          pracowników, współpracowników,
          <span class="collapse" id="virtualCardDataOwnership">
              klientów lub partnerów, którym mają zostać przekazane
            Wirtualne Karty Pluxee. Zgodnie z obowiązującymi regulacjami prawnymi dotyczącymi zasad
            przetwarzania danych osobowych oświadczam, że dane te mogą być przekazane do Pluxee i
            wydawcy Karty w celu związanym z wydaniem i użytkowaniem Wirtualnej Karty Pluxee.
          </span>
          <a data-toggle="collapse" data-target="#virtualCardDataOwnership" @click="showVirtualCardDataOwnership = !showVirtualCardDataOwnership">
            <b> [{{ showVirtualCardDataOwnership ? 'zwiń' : 'rozwiń'}}]</b>
          </a>
        </label>
      </div>
      <ul class="errors">
        <li :key="idx" class="text-danger" v-for="(error,idx) in errors">{{ error }}</li>
      </ul>
    </ValidationProvider>

    <ValidationProvider
      :rules="{ required: { allowFalse: false } }" class="additionalForm__agreements" name="infoIsRegulationChecked"
      ref="infoIsRegulationChecked"
      tag="div"
      v-slot="{ errors, dirty, valid , classes }">
      <div>
        <label class="checkbox-inline required" :class="errors.length > 0 ? 'invalid' : ''">
          <input
            class="dl-checked"
            name="infoIsRegulationChecked"
            type="checkbox"
            v-model="isRegulationChecked"
          >
          <template v-if="checkProductsIsOpenEVoucher">
               Oświadczam, że zapoznałem się i akceptuję warunki określone w
              <a href="/docs/Pluxee_Ogólne warunki umowy eVoucher Pluxee_01.09.2025.pdf" target="_blank">Ogólnych Warunkach Umowy Sprzedaży</a> oraz
              <a href="/docs/regulamin-uzytkownika-evoucher-09-2025.pdf" target="_blank">Regulaminie dla Użytkownika końcowego</a>.
          </template>
          <template v-else-if="hasIndividualRegulations">
            Oświadczam, że zapoznałem się z
            <span v-for="(item, i) in individualRegulations" :key="item.label">
              <a :href="item.url" target="_blank">{{ item.label }}</a>
              <span>{{ getIndividualRegulationsConjunction(i) }}</span>
            </span>
            i akceptuję ich treść.
          </template>
          <template v-else>
              Oświadczam, że zapoznałem się z
              <template v-if="isProductPhysicalCard">
                <a href="/docs/owu-pluxee.pdf" target="_blank" >Ogólnymi warunkami świadczenia usług („OWU”)</a> i akceptuję ich treść.
              </template>
              <template v-if="getProductType === 'ECV_ISS'">
                <a href="/docs/owuw-pluxee.pdf" target="_blank" >Ogólnymi warunkami świadczenia usług („OWUW”)</a> i akceptuję ich treść.
              </template>
              <template v-if="getProductType === 'V_ISS'">
                <a href="/docs/regulamin-zamawiania-kuponow-pluxee.pdf" target="_blank" >Regulaminem Systemu Kuponów</a> i akceptuję ich treść.
              </template>
            <template v-if="isProductsMonoEVoucher || isProductVirtualNDE">
              akceptuję jego treść.
            </template>
          </template>
        </label>
        <ul class="errors">
            <li :key="idx" class="text-danger" v-for="(error,idx) in errors">{{ error }}</li>
        </ul>
      </div>
    </ValidationProvider>

    <ValidationProvider
      v-if="isProductsMonoEVoucher"
      :rules="{ required: { allowFalse: false } }"
      class="additionalForm__agreements" name="isEvoucherPartnerAgreementChecked"
      ref="isEvoucherPartnerAgreementChecked"
      tag="div"
      v-slot="{ errors, dirty, valid , classes }">

      <div>
        <label class="checkbox-inline required text-collapse" :class="errors.length > 0 ? 'invalid' : ''">
          <input
            class="dl-checked"
            name="isEvoucherPartnerAgreementChecked"
            type="checkbox"
            v-model="isEvoucherPartnerAgreementChecked" >
          Oświadczam, że: <br>
          - zapoznałem/am się i akceptuję treść
          <a :href="getRegLinkFromStore" target="_blank">regulaminu korzystania z eVoucherów</a>
          wybranych
          <span class="collapse" id="eVoucherPartnerAgreement">
              przeze mnie w ramach niniejszego zamówienia, które to regulaminy dostępne
            są na stronach internetowych wydawców eVoucherów; <br>
            - jestem świadomy, że regulaminy
            korzystania z eVoucherów wybranych w ramach niniejszego zamówienia zostały przygotowane
            przez wydawców eVoucherów, w związku z czym Pluxee nie ponosi odpowiedzialności za ich treść.
          </span>
          <a data-toggle="collapse" data-target="#eVoucherPartnerAgreement" @click="showEVoucherPartnerAgreement = !showEVoucherPartnerAgreement">
            <b> [{{ showEVoucherPartnerAgreement ? 'zwiń' : 'rozwiń'}}]</b>
          </a>
        </label>
      </div>
      <ul class="errors">
        <li :key="idx" class="text-danger" v-for="(error,idx) in errors">{{ error }}</li>
      </ul>
    </ValidationProvider>

    <ValidationProvider
      v-if="isProductsMonoEVoucher"
      :rules="{ required: { allowFalse: false } }" class="additionalForm__agreements" name="isWithdrawalAgreementChecked"
      ref="isWithdrawalAgreementChecked"
      tag="div"
      v-slot="{ errors, dirty, valid , classes }">

      <div>
        <label class="checkbox-inline required text-collapse" :class="errors.length > 0 ? 'invalid' : ''">
          <input
            class="dl-checked"
            name="isWithdrawalAgreementChecked"
            type="checkbox"
            v-model="isWithdrawalAgreementChecked"
          >
          Jeżeli eVoucher(y) zamawiane są przez osobę fizyczną prowadzącą działalność gospodarczą, bezpośrednio w związku z prowadzoną działalnością gospodarczą,
          gdy Umowa
          <span class="collapse" id="withdrawalAgreement">
             sprzedaży nie ma charakteru zawodowego*, oświadczam, że wyrażam zgodę na dostarczenie przez Pluxee eVouchera(ów) w terminie uprawniającym mnie do odstąpienia od Umowy sprzedaży.
            Przyjmuję do wiadomości, że wiąże się to z utratą przysługującego mi prawa do odstąpienia od umowy na podstawie art. 38 pkt 13 ustawy z dnia 30 maja 2014 r. o prawach konsumenta.
            W przypadku, gdy eVoucher(y) zamawiane przez inne podmioty lub gdy Umowa sprzedaży ma charakter zawodowy, przyjmuje do wiadomości, że jako przedsiębiorcy,
            nie przysługuje mi prawo do odstąpienia od Umowy sprzedaży eVoucherów objętych zamówieniem.
            <br><br>
            *osoba o której mowa w art 38a ustawy z dnia 30 maja 2014 r. o prawach konsumenta (Dz. U.z 2020, poz 287 z późn. zm.).
          </span>
          <a data-toggle="collapse" data-target="#withdrawalAgreement" @click="showWithdrawalAgreement = !showWithdrawalAgreement">
            <b> [{{ showWithdrawalAgreement ? 'zwiń' : 'rozwiń'}}]</b>
          </a>
        </label>
      </div>
      <ul class="errors">
        <li :key="idx" class="text-danger" v-for="(error,idx) in errors">{{ error }}</li>
      </ul>
    </ValidationProvider>

    <ValidationProvider
      v-if="checkProductsIsOpenEVoucher"
      :rules="{ required: { allowFalse: false } }" class="additionalForm__agreements" name="isWithdrawalAgreementChecked"
      ref="isWithdrawalAgreementChecked"
      tag="div"
      v-slot="{ errors, dirty, valid , classes }">

      <div>
        <label class="checkbox-inline required text-collapse" :class="errors.length > 0 ? 'invalid' : ''">
          <input
            class="dl-checked"
            name="isWithdrawalAgreementChecked"
            type="checkbox"
            v-model="isWithdrawalAgreementChecked"
          >
          Oświadczam, że wyrażam zgodę na dostarczenie przez Pluxee eVouchera(ów)
          Pluxee lub wybranych przeze mnie Usług dodatkowych w terminie uprawniającym
          mnie do odstąpienia od Umowy. Przyjmuję do wiadomości, że może się to wiązać
          z utratą przysługującego mi prawa do odstąpienia od umowy na podstawie
          art. 38 ust. 1 pkt 1 ustawy o prawach konsumenta.
        </label>
      </div>
      <ul class="errors">
        <li :key="idx" class="text-danger" v-for="(error,idx) in errors">{{ error }}</li>
      </ul>
    </ValidationProvider>
  </div>
</template>

<script>

import { mapFields } from 'vuex-map-fields';
import { resolveIndividualRegulations } from '@/utils/regulations';

export default {
  name: 'AdditionalInfoAgreements',
  components: {},
  computed: {
    ...mapFields('additionalInfo', [
      'isRegulationChecked',
      'isMarketingMailAgreementChecked',
      'isMarketingPhoneAgreementChecked',
      'isProfileAgreementChecked',
      'isEvoucherPartnerAgreementChecked',
      'isWithdrawalAgreementChecked',
      'isVirtualCardDataOwnershipChecked',
    ]),
    getProductType() {
      return this.$store.getters.getProductType;
    },
    isProductEVoucher() {
      return this.$store.getters.isProductEVoucher;
    },
    isProductsMonoEVoucher() {
      return this.$store.getters.isProductsMonoEVoucher;
    },
    isProductPhysicalCard() {
      return this.$store.getters.isProductPhysicalCard;
    },
    isProductVirtualNDE() {
      return this.$store.getters.isProductVirtualNDE;
    },
    checkProductsIsOpenEVoucher() {
      return this.$store.getters.isProductsOpenEVoucher;
    },
    product() {
      return this.$store.getters.allProducts[0];
    },
    getRegLinkFromStore() {
      return this.product.reg_link;
    },
    hasIndividualRegulations() {
      return this.individualRegulations.length > 0;
    },
    individualRegulations() {
      return resolveIndividualRegulations(this.product);
    },
  },
  methods: {
    getIndividualRegulationsConjunction(index) {
      const regulationsCount = this.individualRegulations.length;
      if (index >= regulationsCount - 1) return '';
      if (index === regulationsCount - 2) return ' oraz ';
      return ', ';
    },
  },
  created() {
    this.isRegulation = this.isRegulationChecked;
  },
  data() {
    return {
      isRegulation: false,
      showVirtualCardDataOwnership: false,
      showEVoucherPartnerAgreement: false,
      showWithdrawalAgreement: false,
    };
  },
};
</script>

<style lang="scss" scoped>
  section {

    display: flex;
    flex-direction: column;

    label {
      margin-bottom: 15px;
    }
  }
</style>
